import { MiningCoinConversion } from "../models/mcc.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getMiningCoinConversions = (miningMachineId: number) : Promise<MiningCoinConversion[]> => {
    return new Promise<MiningCoinConversion[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/miningcc/${miningMachineId}`).then((response) => {
            resolve(response.data as MiningCoinConversion[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};